/**
 * Core Shadow Tokens — Tier 1
 *
 * Raw box-shadow values.
 * JS key maps to Figma token: shadows.md → shadow-md.
 *
 * NOTE: Shadow values currently use raw rgba for the opacity component.
 * These should eventually reference opacity tokens (e.g. opacity[8]) but that
 * pattern is not yet resolved. Tracked as a known gap.
 *
 * Rules:
 * - Tier 2 semantic tokens reference these keys; never raw values
 */

export const shadows = {
  none: 'none',
  xs: '0px 1px 2px rgba(0, 0, 0, 0.08)',
  sm: '0px 2px 4px rgba(0, 0, 0, 0.08)',
  md: '2px 4px 4px 2px rgba(0, 0, 0, 0.08)',
  lg: '0px 4px 8px rgba(0, 0, 0, 0.12)',
  xl: '0px 8px 16px rgba(0, 0, 0, 0.16)',
  '2xl': '0px 12px 24px rgba(0, 0, 0, 0.20)',
} as const;

export type Shadows = typeof shadows;
export type ShadowToken = keyof Shadows;
